import { useEffect, useState } from 'react';
import { get } from '../../services/apiController';
import { toast } from 'react-toastify';
import Select from 'react-select';

const Item = (props) => {
  const { invItems, itemId, onChange, name, isDisabled = false, query, type, locationId, excludeItemIds = [] } = props;

  const [items, setItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);

  const getItems = () => {
    try {
      get(`/inv/items/?${query ?? ''}`).then((response) => {
        setItems(response?.data?.rows);
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  };

  useEffect(() => {
    // Let's not load the items if they are already passed by parent
    if (invItems?.length) {
      setItems(invItems);
    } else {
      getItems();
    }
  }, []);

  useEffect(() => {
    if (itemId) {
      const item = items.find((ele) => ele.id === +itemId);
      setSelectedItem({ value: item?.id, label: item?.name });
    }
  }, [itemId, items]);

  const options = items
    .filter((item) => (locationId === '116' ? item.class === 'Godown' : true))
    .filter((item) => !excludeItemIds.includes(item.id)) // Filter out already selected items
    .map((item) => ({
      value: item?.id,
      label: item?.name,
    }));

  return (
    <Select
      name={name}
      placeholder="Select Item"
      isDisabled={isDisabled}
      value={selectedItem}
      isClearable
      isSearchable
      options={options}
      onChange={(selectedItem) => {
        setSelectedItem({ value: selectedItem?.value, label: selectedItem?.label });
        onChange(selectedItem?.value ?? '');
      }}
      styles={{
        control: (provided, state) => ({
          ...provided,
          minHeight: '55px', // Adjust the height value as needed
        }),
      }}
    />
  );
};

export default Item;
